export default __webpack_public_path__ + "static/media/smile-default.69adc946.svg";